import { render, staticRenderFns } from "./ContenidoDocente.vue?vue&type=template&id=4388b06f&"
import script from "./ContenidoDocente.vue?vue&type=script&lang=js&"
export * from "./ContenidoDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports